import React from 'react';
import { HomeWrapper } from '../src/components/HomePage/HomeBanner/styled';
import NewFooter from '../src/components/HomePage/NewFooter';
import NewHeader from '../src/components/HomePage/NewHeader';
import { PolicyContainer } from '../src/components/PrivacyPolicy/Overview/styled';
import TermsAndConditionPage from '../src/components/TermsAndConditions';
import GlobalStyle from '../src/styles/globalStylesV2';

function termOfUse(props) {
  return (
    <>
      <GlobalStyle />
      <NewHeader nostrip={true} />
      <HomeWrapper>
        <PolicyContainer>
          <h3 className="term">TERMS &amp; CONDITION OF USE</h3>
          {/* <div>
                        <h3>OVERVIEW</h3>
                        <p className="this_document">
                            This document is an electronic record in terms of
                            the Information Technology Act, 2000 and will be
                            deemed to be a contract formed through electronic
                            means.
                        </p>
                        <p className="blupinInfo">
                            Blupin Technologies Private Limited, a company
                            registered under the Indian Companies Act, 1956,
                            which has its registered office at 820, Sector 17 A,
                            Gurgaon and operates under its trade name
                            &quot;Mylo&quot;, (hereinafter referred to as
                            &quot;Mylo&quot; or &quot;We&quot; or &quot;Us&quot;
                            or &quot;Our&quot; or &quot;Company&quot;). This
                            document is published in accordance with the
                            provisions of Rule 3 (1) of the Information
                            Technology (Intermediaries guidelines) Rules, 2011,
                            that require publishing the rules and regulations,
                            Privacy Policy and Terms of Use (“Terms”) for access
                            or usage of {" "}
                            <a href="https://www.mylofamily.com">
                                www.mylofamily.com
                            </a>
                             and/or usage or downloading its mobile based
                            application, a portal of Blupin Technologies Private
                            Limited. The website and the mobile based
                            application are hereinafter collectively referred to
                            as the &quot;Mylo Web Platforms&quot;.
                        </p>
                        <p className="purpose">
                            For the purpose of these Terms, wherever the context
                            so requires &quot;You&quot;, &quot;Your&quot; or
                            &quot;User&quot; shall mean any natural or legal
                            person who has agreed to become a buyer / service
                            recipient on the Mylo Web Platforms by providing
                            relevant data or uses by way of browsing the website
                            or downloading mobile applications. In addition to
                            this, for the purpose of these Terms, wherever the
                            context so requires “You”, “Your” or “Vendor” shall
                            mean the individual or any legal entity (company,
                            sole-proprietorship, partnership, HUF etc.)
                            representing itself through its authorised
                            representative only, who has completed the Mylo
                            Registration Form as required by Mylo and is listed
                            as a Vendor on the Mylo Web Platforms. Further, for
                            the purpose of these Terms, wherever the context so
                            requires “You”, “Your” or “Consultant” shall mean
                            the individual, who has completed the Mylo
                            Registration Form as required by Mylo and is listed
                            as a Consultant on the Mylo Web Platforms, being a
                            Registered Medical Professional providing online
                            medical consultation services for the Users.
                        </p>
                        <p>
                            When You use any of the services provided by Us
                            through the Mylo Web Platforms, You will be subject
                            to the rules, guidelines, policies, terms, and
                            conditions applicable to such service, and they
                            shall be deemed to be incorporated into these Terms
                            and shall be considered as part and parcel of these
                            Terms. We reserve the right, at Our sole discretion,
                            to change, modify, add or remove portions of these
                            Terms at any time without any prior written notice
                            to You. It is Your responsibility to review these
                            Terms periodically for updates or changes. Your
                            continued use of the Mylo Web Platforms, following
                            the posting of changes will mean that You accept and
                            agree to the revisions. As long as You comply with
                            these Terms, We grant You a personal, non-exclusive,
                            non-transferable, limited privilege to enter, use
                            and download the Mylo Web Platforms.
                        </p>
                        <p>
                            For the purpose of these Terms, wherever the context
                            so requires, “Booking Date” or “Transaction Date”
                            shall mean the date on which the order has been
                            placed by the User for purchasing the products or
                            availing the services of the Vendor via the Mylo Web
                            Platforms. Further, “Date of Service” shall mean the
                            date on which the products will be delivered or the
                            services will be provided by the Vendor.
                        </p>
                        <p>
                            Please note that, accessing, browsing, downloading
                            or otherwise using the Mylo Web Platforms indicates
                            Your agreement to all the Terms. Therefore, please
                            read the Terms carefully before proceeding. By
                            impliedly or expressly accepting these Terms, You
                            also accept and agree to be bound by Mylo’s Policies
                            (including but not limited to our Privacy Policy) as
                            amended from time to time.
                        </p>
                        <p>
                            For the Purpose of these Terms, words referring to
                            masculine include the feminine and the singular
                            include the plural and vice versa as the context
                            admits or requires; and words importing persons
                            includes individuals, bodies corporate and
                            unincorporated.
                        </p>

                        <h3 className="term">
                            A. TERMS &amp; CONDITIONS FOR THE USER
                        </h3>
                        <h3>1. USER ELIGIBILITY</h3>
                        <p>
                            Use of the Mylo Web Platforms is available only to
                            persons who can form legally binding contracts under
                            Indian Contract Act, 1872. Persons who are
                            &quot;incompetent to contract&quot; within the
                            meaning of the Indian Contract Act, 1872 including
                            minors, un-discharged insolvents etc. are not
                            eligible to use the Mylo Web Platforms. If You are a
                            minor i.e. under the age of 18 years, You shall not
                            be eligible as a User of the Mylo Web Platforms and
                            shall not transact on or use the Mylo Web Platforms.
                            Further, if you are a minor, You may only avail the
                            consultation services from the Consultants available
                            on the Mylo Web Platform. Mylo reserves the right to
                            deactivate and / or refuse to provide You with
                            access to the Platforms if it is brought to Our
                            notice or if it is discovered that You are under the
                            age of 18 years.
                        </p>
                        <h3>2. PLATFORM FOR THE PRODUCTS AND SERVICES</h3>
                        <p>
                            2.1. You agree that Mylo acts as a facilitator
                            between the User and the Vendor and User and the
                            Consultant (as the case may be). It is a platform
                            through which Users can (a) purchase various goods
                            and avail services related to child care and care
                            for their family from third party Vendors all over
                            India; and (b) avail medical consultation services
                            from Consultants.
                        </p>
                        <p>
                            2.2. Mylo is only a platform that can be utilized by
                            Users to reach a larger base to buy and sell
                            products or avail medical consultation services.
                            Mylo is only providing a platform for communication
                            and it is agreed that: (a) any sale of the products
                            or services shall be a strictly bipartite
                            understanding between the User and the Vendor; and
                            (b) consultation services availed including purchase
                            and consumption of medicines prescribed by the
                            Consultant based on the online diagnosis shall be a
                            strictly bipartite understanding between the User
                            and the Consultant.
                        </p>
                        <p>
                            2.3. We enable parents to connect with experts and
                            other parents to make better and more informed
                            decisions. The services provided by Mylo include,
                            but are not limited to, reviewing, rating,
                            commenting, communicating with other Users,
                            Consultants and/or Vendors.
                        </p>
                        <h3>3. YOUR ACCOUNT</h3>
                        <p>
                            3.1. In consideration of Your use of the Mylo Web
                            Platforms, You agree to:
                        </p>
                        <p>
                            3.1.1. Provide accurate, current and complete
                            information about You as may be prompted by any
                            registration forms and subscription, including, but
                            without limiting, Your name, telephone number,
                            mailing address, bank account details, account and
                            email address on the Mylo Web
                            Platforms (&quot;Registration Data&quot;);
                        </p>
                        <p>
                            3.1.2. Maintain and promptly update the Registration
                            Data, and any other information You provide to Mylo,
                            to keep it accurate, current and complete;
                        </p>
                        <p>
                            3.1.3. Maintain confidentiality of Your password and
                            identification;
                        </p>
                        <p>
                            3.1.4. Notify Mylo immediately of any unauthorized
                            use of Your account or any other breach of security;
                        </p>
                        <p>
                            3.1.5. Where You have availed the online medical
                            consultation services, You shall provide accurate
                            answers to questions posed by the Consultants and
                            all information necessary shall be informed to the
                            Consultant;
                        </p>
                        <p>
                            3.1.6. Any licenses, permits, consents, approvals
                            and intellectual property or other rights as may be
                            required for using the services shall be obtained by
                            You at Your own cost;
                        </p>
                        <p>
                            3.1.7. Accept all responsibility for any and all
                            activities that occur under Your account (whether
                            through authorized or unauthorized access)
                            including, but without limitation to, information
                            retrieved, stored and transmitted through the Mylo
                            Web Platforms by You;
                        </p>
                        <p>
                            3.1.8. Accept all risks of unauthorized access to
                            the Registration Data and any other information You
                            provide to Mylo; and
                        </p>
                        <p>
                            3.1.9. You will ensure compliance with all notices
                            or instructions given by Mylo from time to time to
                            enable the use of the the Mylo Web Platforms.
                        </p>
                        <p>
                            3.2. You agree that if You provide any information
                            that is untrue, inaccurate, not current or
                            incomplete or We have reasonable grounds to suspect
                            that such information is untrue, inaccurate, not
                            current or incomplete, or not in accordance with
                            these Terms, We shall have the right to indefinitely
                            suspend or terminate or block access of Your account
                            on the Mylo Web Platforms and refuse to provide You
                            with access to the Mylo Web Platforms.
                        </p>
                        <p>
                            3.3. You agree and consent to receive all
                            communications at the mobile number provided, even
                            if this mobile number is registered under DND/NCPR
                            list under TRAI regulations. And for that purpose,
                            you further authorise Company to share/disclose the
                            information to any third party service provider or
                            any affiliates, group companies, their authorised
                            agents or third party service providers.
                        </p>
                        <h3>4. INVITATION TO OFFER</h3>
                        <p>
                            All products, services and information displayed on
                            the Mylo Web Platforms constitute an invitation to
                            offer. Your order for purchase of products or
                            availing the services constitutes Your offer, which
                            shall be subject to the Terms as listed herein. Mylo
                            reserves the right to accept or reject Your offer in
                            part or in full, with or without any reason
                            whatsoever. The acceptance and / or communication to
                            the Vendor of Your offer for the purchase of the
                            products or availing the services will take place
                            upon the dispatch of your products or provision of
                            the services availed by You. No act or omission
                            prior to the actual dispatch of the products or the
                            provision of services to You will constitute
                            acceptance of Your offer.
                        </p>
                        <h3>5. REGISTRATION</h3>
                        <p>
                            5.1. Mylo allows You to either sign in to the Mylo
                            Web Platforms with Your Facebook account or to sign
                            in with Your email address to register with Us.
                        </p>
                        <p>
                            5.2. Mylo is only a platform that can be utilized by
                            Users to reach a larger base to buy and sell
                            products or services. Mylo is only providing a
                            platform for communication and it is agreed that any
                            sale of the products or services shall be a strictly
                            bipartite understanding between the User and the
                            Vendor.
                        </p>
                        <p>
                            5.3. Registration on the Mylo Web Platforms is free
                            for Users. Mylo does not charge the User any fee for
                            browsing and ordering on the Mylo Web Platforms.
                            Mylo reserves the right to change its fee policy
                            from time to time. In particular, Mylo may at its
                            sole discretion introduce new services and modify
                            some or all of the existing services offered on the
                            Mylo Web Platforms. In such an event Mylo reserves
                            the right to introduce fees for the new services
                            offered or amend/introduce fees for existing
                            services, as the case may be. Changes to the fee
                            policy shall be posted on the Mylo Web Platforms and
                            such changes shall automatically become effective
                            immediately after they are posted on the Mylo Web
                            Platforms. Unless otherwise stated, all fees shall
                            be quoted in Indian Rupees. You shall be solely
                            responsible for compliance with all applicable laws
                            including those in India for making payments to Mylo
                        </p>
                        <h3>
                            6. TERMS &amp; CONDITIONS FOR OBJECTIONABLE CONTENT
                        </h3>
                        <p>
                            6.1 Mylo has a zero tolerance policy regarding
                            objectionable content. Objectionable content may not
                            be uploaded or displayed to the extent such content
                            includes, is in conjunction with, or alongside any,
                            Objectionable Content includes, but is not limited
                            to: (i) sexually explicit materials, (ii) obscene,
                            defamatory, libelous, slanderous, violent and/or
                            unlawful content or profanity! (iii) content that
                            infringes upon the rights of any third party,
                            including copyright, trademark, privacy, publicity
                            or other personal or proprietary right, or that is
                            deceptive or fraudulent! (iv) content that promotes
                            the use or sale of illegal or regulated substances,
                            tobacco products, ammunition and/or firearms; and
                            (v) gambling, including without limitation, any
                            online casino, sports books, bingo or poker. Any
                            user can flag content they deem objectionable for
                            review. Content will be moderated by Mylo to ensure
                            the timely removal of any and all objectionable
                            content. User accounts which have been confirmed
                            responsible for Peeling objectionable content will
                            be restricted from access to the Mylo app.
                        </p>

                        <h3>7. GENERAL TERMS AND TAKEDOWN POLICY</h3>
                        <p>
                            7.1. By registering with us as per Clause 5 and
                            transacting via the Mylo Web Platforms to purchase
                            any products or avail the online medical consultancy
                            services, You represent to Mylo that such
                            registration and purchase is for Your personal and
                            non-commercial use only. Further while using the
                            Mylo Web Platforms, You acknowledge that You fully
                            assume the risks of purchase and sale transactions
                            and You further fully assume the risks of liability
                            or harm of any kind in connection with subsequent
                            activity of any kind relating to the product(s)
                            and/or service(s) that are the subject of the
                            transactions via the Mylo Web Platforms. In addition
                            to the above, You acknowledge that by availing the
                            online medical consultation services from any
                            Consultant registered on the Mylo Web Platforms, You
                            fully assume the risks of harm in connection with a
                            wrongful diagnosis and further undertake that You
                            shall not at any point make any claim against Us.
                        </p>
                        <p>
                            7.2. Mylo reserves the right, at its sole and
                            absolute discretion, to determine whether anything
                            posted by You is appropriate; and to remove it,
                            without notice or liability to You, which it
                            determines to be inappropriate. Without limiting the
                            generality of the foregoing, the following is a
                            partial and non-exhaustive list of the type of
                            activities that Mylo deems to be inappropriate:
                        </p>
                        <p>
                            7.2.1. Content that criticizes a business or
                            individual beyond that of merely offering an
                            opinion;
                        </p>
                        <p>
                            7.2.2. Content that harasses or advocates harassment
                            of another person;
                        </p>
                        <p>
                            7.2.3. Content that exploits people in a sexual or
                            violent manner;
                        </p>
                        <p>
                            7.2.4. Content that contains nudity, violence, or
                            offensive subject matter or contains a link to an
                            adult website;
                        </p>
                        <p>
                            7.2.5. Content that includes racially, ethically, or
                            otherwise objectionable language;
                        </p>
                        <p>
                            7.2.6. Content that is libelous, defamatory, or
                            otherwise tortious language;
                        </p>
                        <p>
                            7.2.7. Content that solicits personal information
                            from anyone under 18 years of age;
                        </p>
                        <p>
                            7.2.8. Content that promotes information known to be
                            false or misleading or promotes illegal activities
                            or conduct that is abusive, threatening, obscene,
                            defamatory or libelous;
                        </p>
                        <p>
                            7.2.9. Content that involves the transmission of
                            &quot;junk mail,&quot; &quot;chain letters,&quot; or
                            unsolicited mass mailing, instant messaging,
                            &quot;spimming,&quot; or &quot;spamming&quot;;
                        </p>
                        <p>
                            7.2.10 Content that is in breach of any rights of a
                            third party including but not limited to
                            intellectual property rights.
                        </p>
                        <p>
                            7.2.11 Copying, modifying, translating, publishing,
                            broadcasting, transmitting, licensing, sublicensing,
                            assigning, distributing, performing, publicly
                            displaying, or selling any Mylo content appearing on
                            or through the Mylo Web Platforms. It is further
                            clarified that where any User/third party makes any
                            complaint with regards to another User’s uploading
                            of contents mention under Clause 7.2 above, such
                            User/third party may intimate Mylo and after
                            investigation Mylo shall be entitled to take down
                            such content if it is deemed to be a valid complaint
                            based on Mylo’s investigation.
                        </p>
                        <p>
                            7.3. Mylo expressly reserves the right to
                            investigate and take appropriate legal action
                            against anyone who, in Mylo’s sole discretion,
                            violates this provision, including without
                            limitation, reporting You to the law enforcement
                            authorities.
                        </p>
                        <p>
                            7.4 If any content uploaded by Mylo on the Mylo Web
                            Platforms is violative of any right of a User or
                            third party (as the case may be) including but not
                            limited to intellectual property rights, then
                            pursuant to a complaint made by such person to Mylo
                            and a subsequent investigation of the origins of
                            such content in question, Mylo shall take down such
                            content where the complaint has been deemed valid.
                            It is hereby clarified that to the extent no
                            complaint has been received against any content
                            uploaded by Mylo it shall be deemed that such
                            content is being used by Mylo in a valid manner with
                            the explicit consent of the actual owner of such
                            content (if applicable).
                        </p>
                        <h3>
                            {" "}
                            <a id="paymentPolicy" className="anchor"></a> 8.
                            PAYMENT
                        </h3>
                        <p>
                            8.1. While availing any of the payment method/s
                            available on the Mylo Web Platforms, We will not be
                            responsible or assume any liability, whatsoever in
                            respect of any loss or damage arising directly or
                            indirectly to You due to:
                        </p>
                        <p>
                            8.1.1. Lack of authorization for any transaction/s,
                            or
                        </p>
                        <p>
                            8.1.2. Exceeding the preset limit mutually agreed
                            between You and the financial services providers you
                            deal with, or
                        </p>
                        <p>
                            8.1.3. Any payment issues arising out of the
                            transaction, or
                        </p>
                        <p>
                            8.1.4. Decline of transaction for any other reason/s
                        </p>
                        <p>
                            8.2. All payments made against any purchase of the
                            products or availing the services, shall be
                            compulsorily in Indian rupees (“Transaction Price”).
                        </p>
                        <p>
                            8.3. Before delivering the products purchased by You
                            or providing the services to You, the Vendor may
                            request You to provide supporting documents
                            (including but not limited to Govt. issued ID and
                            address proof) to establish the ownership of the
                            payment instrument used by You for Your purchase.
                            This is done in the interest of providing a safe
                            online shopping environment to Our Users.
                        </p>
                        <p>
                            8.4. You have specifically authorized Mylo or its
                            Vendors to collect, process, facilitate and remit
                            the Transaction Price electronically or through Cash
                            on Delivery to and from other Users in respect of
                            transactions through payment facility.
                        </p>
                        <h3>9. CANCELLATION POLICY</h3>
                        <p>
                            9.1. Cancellation before the date of dispatch of
                            products: Once an order for purchasing the products
                            available for sale on the Mylo Web Platforms is
                            received by Us and the checkout procedure is
                            completed, a cancellation of such an order can only
                            be made at any time before You receive an email
                            containing confirmation of dispatch of the product
                            from the Vendor. No cancellations will be accepted
                            post such time and any cancellation request received
                            post such time shall be deemed to be a request for
                            return of the product and shall be subject to the
                            return and refund policy as provided for in Clause
                            9. For the purpose of cancelling the order placed by
                            You, You can either send us an email on
                            feedback@mylofamily.com with Your order details such
                            as Your name, address, telephone number, order
                            number, booking date, etc. or You can call Our
                            customer care and give directions for cancellation
                            of Your order.
                        </p>
                        <p>
                            9.2. Cancellation before the date of service: Once
                            an order for availing of services on the Mylo Web
                            Platforms is received by Us and the checkout
                            procedure is completed, a cancellation of such order
                            for a service can be made 48 hours prior to the date
                            of service. No cancellation of such order will be
                            accepted if made less than 48 hours prior to the
                            date of service. For the purpose of cancelling the
                            service, You can either send Us an email on
                            feedback@mylofamily.com with Your order details such
                            as Your name, address, telephone number, order
                            number, booking date, etc. Or You can call our
                            customer care and give directions for cancellation
                            of Your order. In case of cancellations made by You
                            48 hours or more before the date of service, 20%
                            will be deducted from the total payment amount due
                            from You after which the refund will be initiated as
                            per Clause 9. 8.3. Cancellation after the date of
                            service: Subject to clause 9, for all such services
                            which are availed of over a period of time, no
                            cancellation will be accepted under any
                            circumstances after the date on which the services
                            have commenced. Under such circumstances, Mylo will
                            not be liable to refund or return any amount paid by
                            You, irrespective of whether the services have been
                            availed by You or not.
                        </p>
                        <h3>10. RETURN AND REFUND POLICY</h3>
                        <p>
                            10.1. Please note that all returns and related
                            procedures shall be carried out by the Vendor(s)
                            whose products have been purchased by You.
                            Therefore, Mylo shall not be liable for any loss,
                            damages, action, claim or liability arising out of
                            or in connection with any act, omission or
                            negligence of such a Vendor with respect to the
                            return of purchased product(s).
                        </p>
                        <p>
                            10.2. Subject to the restrictions contained in Our
                            cancellation policy, a request for the cancellation
                            of Your order can be sent to Mylo before the date of
                            service and before You receive an email containing
                            confirmation of dispatch of the products.
                        </p>
                        <p>
                            10.3. Once the cancellation has been accepted by
                            Mylo, You will be intimated about the same by way of
                            an email or a phone call on the e-mail ID and
                            telephone number provided by You. Any refund against
                            a request for a return or the products shall be
                            processed only upon receipt of the product by the
                            Vendor along with the original invoice. In case of
                            services intended to be availed by You, the refund
                            will be subject to the cancellation policy as per
                            Clause 8. It may take up to 10-14 business days for
                            the credit to reflect in Your account. The actual
                            time taken for refund or credit of the payment into
                            your account depends on the mode by which the
                            payment was made and the procedures adopted by
                            various financial services providers.
                        </p>
                        <h3>11. CONFIDENTIAL AND PERSONAL DATA/INFORMATION</h3>
                        <p>
                            11.1. Any personal and identifiable information that
                            is required to be collected by Us shall be kept
                            confidential in accordance with the provisions of
                            our Privacy Policy. In addition to the Privacy
                            Policy, the provisions of the following laws/ rules/
                            guidelines/ regulations shall be applicable to the
                            use of these Platforms:
                        </p>
                        <p>
                            11.1.1. The provisions of Information Technology
                            Act, 2000 relating to the processing of personal
                            data as may be amended from time to time;
                        </p>
                        <p>
                            11.1.2. The provisions of the Information Technology
                            (Intermediary Guidelines) Rules, 2011 as may be
                            amended from time to time;
                        </p>
                        <p>
                            11.1.3. The provisions of the Information Technology
                            (Reasonable Security Practices and Procedures and
                            Sensitive Personal Data or Information) Rules, 2011
                            as may be amended from time to time.
                        </p>
                        <p>
                            11.1.4. The provisions of the Telemedicine Practice
                            Guidelines, 2020.
                        </p>
                        <h3>12. INTELLECTUAL PROPERTY RIGHTS</h3>
                        <p>
                            12.1. Subject to Part B Clause 6, Mylo is the sole
                            owner or lawful licensee of all the rights of the
                            Mylo Web Platforms and its content. For the purpose
                            of this clause, the content on the Mylo Web
                            Platforms includes its design, layout, text, images,
                            graphics, sound, video, etc as well as non
                            superficially visual functional elements. The title,
                            ownership and intellectual property rights in the
                            Mylo Web Platforms and its content shall remain with
                            Mylo, its affiliates or licensors of the content, as
                            the case may be.
                        </p>
                        <p>
                            12.2. Trademark: &apos;Mylo&apos; and related icons
                            and logos are registered or registration has been
                            applied for by Mylo in various jurisdictions and the
                            same is protected under applicable trademark and
                            other intellectual property laws. The unauthorized
                            copying, modification, use or publication of these
                            marks is strictly prohibited and shall be subject to
                            appropriate legal proceedings against the
                            unauthorized user.
                        </p>
                        <p>
                            12.3. Copyright: All content on the Mylo Web
                            Platforms is the copyright of Mylo except the third
                            party content and links to third party websites on
                            the Mylo Web Platforms, if any.
                        </p>
                        <h3>13. CONSULTATION SERVICES TERMS</h3>
                        <p>
                            Users expressly acknowledge, understand and agree to
                            the following terms in respect of the consultation
                            services available on the Mylo Web Platforms:{" "}
                        </p>
                        <p>
                            13.1. Where any prescription is being provided to
                            User by the Consultant, the same is being provided
                            basis the online consultation, however it may vary
                            when examined in person, hence, in no event shall
                            the prescription provided by Consultants be relied
                            upon as a final and conclusive solution.
                        </p>
                        <p>
                            13.2. Users agree to use the advice from a
                            Consultant on the Mylo Web Platform pursuant to: (a)
                            an ongoing treatment with their medical Consultant;
                            (b) a condition which does not require emergency
                            treatment, physical examination or medical
                            attention; (c) medical history available as records
                            with them for reference; (d) a record of physical
                            examination and report thereof with them, generated
                            through their local medical Consultant; and (e)
                            consultation with their medical Consultant before
                            abandoning or modifying their ongoing treatment.
                        </p>
                        <p>
                            13.3. Users acknowledge and accept that the
                            Consultant shall not be able to conduct a proper
                            physical examination of the Users, hence, they may
                            not have or be able to derive important information
                            that is usually obtained through a physical
                            examination. User acknowledges and agrees that the
                            User is aware of this limitation and agrees to
                            assume the complete risk of this limitation.
                        </p>
                        <p>
                            13.4. The User understands that the consultation
                            services available on the Mylo Web Platforms shall
                            not form a substitute for treatment that otherwise
                            needs physical examination/immediate consultation.
                            Further, the User understands that the advice
                            provided by the Consultant is based on general
                            medical conditions and practices prevalent in India,
                            to the best of his knowledge and ability, and not
                            for conditions which are territory specific for
                            regions other than India, irrespective of where the
                            User is procuring medical services or engaging in
                            communication with the Consultant.
                        </p>
                        <p>
                            13.5. Users shall not use abusive language while
                            availing the consultation services on the Mylo Web
                            Platform. In the event an abuse from the User is
                            reported by a Consultant, Mylo reserves the right to
                            block such Users from availing the consultation
                            services or based on Our sole discretion block You
                            from accessing the Mylo Web Platforms and Mylo shall
                            not be responsible for honouring any refund request
                            towards his/her consultation on the Mylo Web
                            Platform.
                        </p>
                        <p>
                            13.6. Users may share images or videos of the
                            affected areas of their body parts with the
                            Consultant only if it is absolutely necessary for
                            diagnosing his/her condition and if he/she is
                            personally comfortable in sharing such images or
                            videos. In any event, Mylo shall not be responsible
                            for any such images or videos shared by the Users
                            with the Consultants.
                        </p>
                        <p>
                            13.7. Users shall ensure that any
                            interaction/communication with the Consultants,
                            including sharing images or videos of the body
                            parts, shall be only through the Mylo Web Platform.
                            The Users shall not rely on any other external modes
                            of communication for interacting/communicating with
                            the Consultants
                        </p>
                        <p>
                            13.8. Users shall be prepared to share all relevant
                            documents or reports to the Consultant promptly upon
                            request.
                        </p>
                        <p>
                            13.9. For every paid consultation availed on the
                            Mylo Web Platform, the Users shall not obtain
                            consultation for more than one person (including the
                            User). In the event, a User attempts to obtain
                            consultation for one or more person other than
                            himself/herself, through a single paid consultation
                            on the Mylo Web Platforms, such consultations will
                            not be addressed by the relevant Consultant.
                        </p>
                        <p>
                            13.10. Users shall not persuade Consultants to
                            prescribe drugs (including higher dose strength)
                            that do not conform to applicable law and any
                            policies that the Company may implement from time to
                            time. The restricted drugs are as follows: (A)
                            Medication for Medical Termination of Pregnancy
                            (MTP); and (B) Drugs under the following
                            pharmaceutical classifications such as; sedatives,
                            hypnotics, opioids, schedule X drugs, or fourth
                            generation antibiotics.{" "}
                        </p>
                        <p>
                            13.11. Users shall always provide accurate
                            information and will not use the Consult platform
                            for any acts that are considered to be illegal in
                            nature.{" "}
                        </p>
                        <p>
                            13.12. Where a User has decided to avail the
                            consultation services offered on the Mylo Web
                            Platforms and engages with a Consultant to procure
                            medical services or engages in communication,
                            exchange of money for services outside of the Mylo
                            Web Platforms, User shall do so at their own risk.
                            Mylo shall not be responsible for any breach of
                            service or service deficiency by any Consultant.{" "}
                        </p>
                        <p>
                            13.13. The User agrees and understands that the
                            transaction with the Consultant are subject to
                            jurisdiction of Indian laws and that any claim,
                            dispute or difference arising from it shall be
                            subject to the jurisdiction provision as contained
                            in the Terms hereunder, at all times. The User
                            further agrees and understands that the Consultant
                            is a registered medical Consultant who is licensed
                            to practice medicine in India and the onus is on the
                            User to determine if he/she is eligible to consult
                            with the Consultants via the Mylo Web Platforms. It
                            is expressly clarified that at no point in time can
                            it be construed that the Consultant is practicing
                            medicine in a territory other than India,
                            irrespective of where the User is located and
                            procures medical services or engages in
                            communication with the Consultant, in any manner
                            whatsoever.{" "}
                        </p>
                        <h3>14. DISCLAIMER OF WARRANTIES</h3>
                        <p>
                            14.1. All the materials and products (including but
                            not limited to software) and services, included on
                            or otherwise made available to You through the Mylo
                            Web Platforms are provided on &quot;as is&quot; and
                            &quot;as available&quot; basis without any
                            representation or warranties, express or implied
                            except otherwise specified in writing.
                        </p>
                        <p>
                            14.2. Mylo does not warrant that: the Mylo Web
                            Platforms will be constantly available, or available
                            at all; or that the information on the Mylo Web
                            Platforms is complete, true, accurate or
                            non-misleading.
                        </p>
                        <p>
                            14.3. As per the guidelines issued by the Government
                            of India, Mylo will not exercise ownership over the
                            goods and services purported to be sold on the Mylo
                            Web Platforms. Thus all commercial/contractual terms
                            are offered by and agreed to between the Users and
                            Vendors alone. The commercial/contractual terms may
                            include, without limitation, price, shipping costs,
                            payment methods, payment terms, date, period and
                            mode of delivery, warranties related to products and
                            services.
                        </p>
                        <p>
                            14.4. Mylo does not make any representation or
                            warranty as to specifics (such as quality, value,
                            salability, etc) of the products or services
                            proposed to be sold or offered to be sold or
                            purchased on the Mylo Web Platforms. Mylo does not
                            implicitly or explicitly support or endorse the sale
                            or purchase of any products or services on the Mylo
                            Web Platforms. By virtue of technical or human
                            error, it may be possible that certain inadvertent
                            errors may occur such as change in the price of the
                            products and services, change in the quantity
                            ordered, description of the products and services
                            and the like. Even though Mylo makes its best
                            efforts to avoid any such errors, We will not accept
                            liability for any such inadvertent errors or
                            omissions.
                        </p>
                        <p>
                            14.5. Mylo doesn’t claim any ownership rights in the
                            text, files, images, photos, video, sounds, musical
                            works, works of authorship, or any other materials
                            that are provided directly by the Vendors and which
                            are uploaded, submitted, or embed on the Mylo Web
                            Platforms.
                        </p>
                        <p>
                            14.6. References that We make to any names, marks,
                            products or services of third parties or hypertext
                            links to third party sites or information do not
                            constitute or imply Our endorsement, sponsorship or
                            recommendation of the third party, of the quality of
                            any product or service, advice, information or other
                            materials displayed, purchased, or obtained by You
                            as a result of an advertisement or any other
                            information or offer in or in connection with the
                            Mylo Web Platforms.
                        </p>
                        <p>
                            14.7. Mylo shall not and is not required to resolve
                            or mediate any disagreements or disputes between the
                            Users and Vendors because of non-performance of any
                            transaction concluded on the Mylo Web Platforms.
                        </p>
                        <p>
                            14.8. Mylo does not make any representation or
                            warranty as to the item-specifics (such as legal
                            title, creditworthiness, identity, etc) of any of
                            its Vendors. You are advised to independently verify
                            the bona fides of any particular Vendor that You
                            choose to deal with on the Mylo Web Platforms and
                            use Your best judgment in that behalf.
                        </p>
                        <p>
                            14.9. You realize and indemnify Mylo and/or any of
                            its officers and representatives from any cost,
                            damage, liability or other consequences of any of
                            the actions of the Users of the Mylo Web Platforms
                            and specifically waive any claims that You may have
                            in this behalf under any applicable law.
                            Notwithstanding its reasonable efforts in that
                            behalf, Mylo cannot take responsibility or control
                            the information provided by other Users which is
                            made available on the Mylo Web Platforms. You may
                            find other User&apos;s information to be offensive,
                            harmful, inconsistent, inaccurate, or deceptive.
                            Please use caution and exercise Your own judgment
                            when using the Mylo Web Platforms
                        </p>
                        <h3 className="term">
                            B. TERMS AND CONDITIONS FOR THE VENDOR
                        </h3>
                        <h3>1. INFORMATION PROVIDED</h3>
                        <p>
                            1.1. The Vendor will be required to provide all
                            details relevant to the products and services
                            intended to be sold by the Vendor, including but not
                            limited to the price, description, contents which
                            will be by way of text descriptions, graphics,
                            pictures and / or videos of the products and
                            services. Such information must not be misleading
                            and must describe the actual condition of the
                            product. Any precautions and / or side effects or
                            any special requirements before or after use of any
                            of the Vendor’s products and services will be
                            displayed on the Mylo Web Platforms at all times.
                        </p>
                        <p>
                            1.2. It is the responsibility of the Vendor to make
                            sure that the information provided to Mylo with
                            respect to the products and services intended to be
                            sold reflects the real-time availability /
                            non-availability of the products and services with
                            the Vendor.
                        </p>
                        <p>
                            1.3. As a Vendor, You are allowed to list item(s)
                            for sale on the Mylo Web Platforms in accordance
                            with the policies which are incorporated by way of
                            reference in these Terms. You must be legally able
                            to sell the item(s) You list for sale on the Mylo
                            Web Platforms. You must ensure that the listed items
                            do not infringe upon the intellectual property,
                            trade secret or other proprietary rights or rights
                            of publicity or privacy rights of third parties.
                        </p>
                        <h3>2. PAYMENT</h3>
                        <p>
                            2.1. The Vendor grants Mylo the right to collect the
                            Transaction Price on behalf of the Vendor in the
                            mode (i.e. payment gateway or cash on delivery)
                            selected by the User of the Mylo Web Platforms. The
                            Vendor agrees that Mylo is neither a trustee of the
                            Vendor nor acting in any fiduciary capacity with
                            respect to any transaction on the Mylo Web
                            Platforms. The payment facility provided by Mylo is
                            merely an online electronic payment system and will
                            not be considered as a banking or financial
                            services.
                        </p>
                        <p>
                            2.2. The Vendor authorises Mylo to raise an invoice
                            on behalf of the Vendor and send it to the User for
                            the products purchased and / or the services
                            availed. Mylo will send a copy of the invoice raised
                            as above to the Vendor.
                        </p>
                        <p>
                            2.3. Mylo reserves the right to deduct a certain
                            amount as commission (“Transaction Fee”) from the
                            Transaction Price for each transaction entered into
                            between the Vendor and the User via the Mylo Web
                            Platforms. Such Transaction Fee is subject to
                            alteration or modification at the sole discretion of
                            Mylo and Mylo will notify the relevant vendors of
                            such altered or modified transaction fee.
                        </p>
                        <h3>3. CANCELLATION AND REFUND POLICY</h3>
                        <p>
                            3.1. The Vendor acknowledges and agrees to the
                            cancellation, return and refund policy stated for
                            Users in Part A Clause 8 and 9 above. In the event
                            that the User cancels an order made on the Mylo Web
                            Platforms;
                        </p>
                        <p>
                            3.1.1. If at the time of cancellation of an order
                            for products, Mylo, the products have not been
                            confirmed to be dispatched by the Vendor, Mylo will
                            inform the Vendor of the cancellation of the order.
                            No payment of any amount whatsoever will be paid to
                            the Vendor.
                        </p>
                        <p>
                            3.1.2. If at the time of cancellation of an order
                            for products, the Vendor has confirmed the dispatch
                            of the Products, Mylo will process a request for
                            return and it shall be the responsibility of Mylo to
                            cause to collect the product and the original
                            invoice from the User. In such an event, if Mylo has
                            paid to the Vendor the Transaction Price, the Vendor
                            undertakes to return to Mylo the full amount
                            received by the Vendor within 48 hours from the
                            receipt of the product from the User. In the event
                            Mylo has not made any payment to the Vendor, Mylo,
                            will at its sole discretion cause a refund of the
                            amount to be paid to the User and will not make any
                            payment to the Vendor.
                        </p>
                        <p>
                            3.1.3. In the event that the Vendor refuses or fails
                            to provide any services agreed to be provided by the
                            Vendor on the Mylo Web Platforms, the Vendor, shall
                            return to Mylo any monies received by the Vendor
                            from Mylo, within 48 hours of the Date of Service.
                            In the event that the Vendor willfully defaults in
                            providing services agreed to have been provided,
                            Mylo reserves the right to inform the Users on its
                            Platforms of the willful default of the Vendor as
                            well as caution them from availing the services of
                            the Vendor.
                        </p>
                        <h3>4. CONFIDENTIALITY</h3>
                        <p>
                            The Vendor acknowledges that it will have access to
                            confidential information of Mylo and the Vendor
                            agrees to keep confidential all data and
                            confidential information and also will not use for
                            its own purpose by any means whatsoever any
                            confidential information which the Vendor has
                            received from Mylo and it will not sell or otherwise
                            make use / make available the confidential
                            information to any third parties. For the purpose of
                            this clause, confidential information shall include
                            but will not be limited to the terms and conditions
                            of these Terms, information pertaining to the User,
                            the terms of understanding between Mylo and the
                            Vendor and all business and financial information
                            relevant to the business of Mylo and any information
                            which is disclosed verbally or in writing,
                            identified as confidential at the time of
                            disclosure. The obligations under this clause shall
                            survive the termination of these Terms.
                        </p>
                        <h3>5. INTELLECTUAL PROPERTY RIGHTS</h3>
                        <p>
                            5.1. Mylo and the Vendor agree that the
                            brands/logos, trademarks, etc., belonging to each
                            Vendor are the exclusive property of the respective
                            Vendor and are not in any manner whatsoever, copied,
                            altered or modified from the brand, logo, trademark
                            etc. of another Vendor. The Vendor recognizes and
                            confirms that Mylo shall not be liable for contents
                            and images shared, uploaded or displayed on the Mylo
                            Web Platforms by the Vendor regarding Products and
                            Services intended to be sold by the Vendor.
                        </p>
                        <p>
                            5.2. The Vendor grants Mylo the right to display and
                            delist the information as provided by the Vendor
                            along with related logo and / or trademark and / or
                            brand name etc.of the Vendor for the purpose of
                            marketing and selling through the Mylo Web
                            Platforms.
                        </p>
                        <h3>6. DISCLAIMER OF WARRANTIES</h3>
                        <p>
                            6.1. The Vendor will make sure that the products are
                            dispatched and delivered or the services are
                            provided as per the Date of Service, along with all
                            the required information and documentation which is
                            necessary for the User to use the product and / or
                            service. The Vendor will keep Mylo informed about
                            the dispatch and delivery of the products and / or
                            services availed by the User. In the event of any
                            default in the delivery of the products or the
                            services availed, the Vendor will immediately update
                            Mylo informing of such non-delivery / delay and the
                            reason thereof;
                        </p>
                        <p>
                            6.2. The Vendor shall procure all necessary
                            certifications and licenses required for being
                            eligible as a Vendor on the Mylo Web Platforms.
                        </p>
                        <p>
                            6.3. The Vendor warrants that the information
                            provided with respect to the products and services
                            intended to sold via the Mylo Web Platforms is true,
                            accurate, complete, specific, detailed and precise
                            and compliant with all the local laws and
                            regulations;
                        </p>
                        <p>
                            6.4. The Vendor warrants that the products sold by
                            the Vendor via the Mylo Web Platforms are not fake,
                            duplicate, damaged, defective, refurbished or
                            previously owned.
                        </p>
                        <p>
                            6.5. The Vendor hereby expressly indemnifies Mylo
                            from any claim, cost, loss, expense or liability
                            arising out of or in connection with any defect and
                            / or deficiency in any of the products purchased or
                            services availed by the User, non-compliance by the
                            Vendor of any law for the time being in force in
                            India or for any other reason whatsoever, when such
                            action, claim, cost, loss, expense or liability may
                            be attributable to any act, omission, negligence or
                            misrepresentation on the part of the Vendor.
                        </p>
                        <h3 className="term">
                            C. TERMS AND CONDITIONS FOR THE CONSULTANT
                        </h3>
                        <h3>1. INFORMATION PROVIDED</h3>
                        <p>
                            1.1. The Consultant shall provide such information
                            as may be requested by Us including but not limited
                            to his qualification, medical registration number,
                            years of experience, field of specialty, address,
                            contact number and any other information as may be
                            required by Us to complete the registration process.{" "}
                        </p>
                        <p>
                            1.2. The Consultant acknowledges and accepts that
                            he/she shall be fully responsible for any error in
                            the information they have shared during the
                            registration process.{" "}
                        </p>
                        <p>
                            1.3. The Consultant may use and disclose the
                            information disclosed by the Consultant for such
                            purposes, including (without limitation) making
                            inquiries through third parties concerning your
                            identity and professional and practice credentials.
                            In addition to this, the Consultant authorises the
                            Company to disclose to third parties such
                            information as required for such purposes.{" "}
                        </p>
                        <p>
                            1.4. The Consultant acknowledges and accepts that
                            Mylo may list your personal profile describing your
                            credentials, experience, registration number,
                            academic background, awards, papers published shall
                            be available for viewing by Users and will be
                            considered non-confidential and non-proprietary.{" "}
                        </p>
                        <h3> 2. TERMS OF CONSULTATION </h3>
                        <p>
                            2.1. The Consultant shall promptly reply to the User
                            after receiving the User’s communication. In case of
                            non-compliance with regard to adhering to the
                            applicable laws/rules/regulations/guidelines by the
                            Consultant, MYLO shall have the right to replace
                            such Consultants for the purpose of consultation to
                            the User.{" "}
                        </p>
                        <p>
                            2.2. The Consultant further understands that, there
                            is a responsibility on the Consultant to treat the
                            User, pari passu, as the Consultant would have
                            otherwise treated the User on a physical one-on-one
                            consultation model.{" "}
                        </p>
                        <p>
                            2.3. The Consultant has the discretion to cancel any
                            consultation at any point in time in cases where the
                            Consultant feels, it is beyond his/her expertise or
                            his/her capacity to treat the User. In such cases,
                            it may trigger a refund to the User and the User has
                            the option of choosing other Consultants. However,
                            it is strongly recommended that the Consultant
                            advise the User and explain appropriately for next
                            steps which may include referring the User for
                            further evaluation.{" "}
                        </p>
                        <p>
                            2.4. In case, the Consultant has marked
                            himself/herself available for a particular
                            consultation on the Mylo Web Platforms and in the
                            event a consultation has been auto allocated to a
                            Consultant, then such Consultants shall ensure to
                            provide a response to the User within five (5)
                            minutes of accepting the consultation and during the
                            active consultation period.
                        </p>
                        <p>
                            2.5. Consultants should provide e-prescriptions to
                            the Users only via the prescription module. However,
                            when the Consultant creates an e-prescription, the
                            Consultant will be required to confirm the
                            e-prescription with their electronic signature
                            explicitly or implicitly by clicking on the
                            signature option made available or any other form of
                            opt-in methods as provided therein. The Consultant
                            hereby agrees and covenants to be responsible and
                            liable for the content of e-prescription and the
                            authenticity of his signature signed electronically.
                        </p>
                        <p>
                            2.6. For a Consultant to complete a consult, it is
                            mandatory to provide a consultation summary via the
                            e-prescription module to all Users. The recommended
                            contents (at least one) of the said consultation
                            summary are as follows: (a) Summary of presenting
                            illness; (b) Provisional diagnosis; (c) Medicine
                            posology including side effects (if any); (d)
                            Lifestyle changes; (e) Other instructions (if any);
                            and (f) Referral for physical consultation (if
                            necessary).{" "}
                        </p>
                        <p>
                            2.7. The Consultant shall provide e-prescriptions to
                            the Users only in accordance to the Telemedicine
                            Practice Guidelines, 2020. However, when the
                            Consultant creates an e-prescription, the Consultant
                            shall be required to confirm the e-prescription with
                            their electronic signature explicitly or implicitly
                            by clicking on the signature option made available
                            or any other form of opt-in methods as provided
                            therein. The Consultant hereby agrees and covenants
                            to be responsible and liable for the content of
                            e-prescription and the authenticity of his signature
                            signed electronically and shall ensure that no
                            medicine/drugs is being prescribed as provided under
                            Schedule X of the Drugs and Cosmetic Rules, 1945 and
                            Narcotic and Psychotropic substances listed in the
                            Narcotic Drugs and Psychotropic Substances, Act,
                            1985.{" "}
                        </p>
                        <p>
                            2.8. The Consultant shall not to request see for
                            images or video of the User&apos;s private body
                            parts in any manner whatsoever until and unless all
                            other options have been exhausted to diagnose the
                            User’s condition and it is absolutely necessary to
                            arrive at a probable diagnosis.{" "}
                        </p>
                        <p>
                            2.9. In the event the Consultant learns about
                            physical abuse, sexual misconduct (especially in
                            minors), or User self-harm (suicide: planned,
                            attempted or completed), the Consultant agrees to
                            report such events to Mylo via the email:
                            grievance@mylofamily.com.
                        </p>
                        <p>
                            2.10. The Consultant acknowledges and agrees that
                            the information that is disclosed by the User at the
                            time of consultation is personal information and is
                            subject to all applicable privacy laws, shall be
                            confidential in nature and subject to User and
                            Consultant privilege.{" "}
                        </p>
                        <p>
                            2.11. The Consultant understands that Mylo makes no
                            promise or guarantee for any uninterrupted
                            communication and the Consultant shall not hold Mylo
                            liable, if for any reason the communication is not
                            delivered to the User(s), or are delivered late or
                            not accessed, despite the efforts undertaken by
                            Mylo.{" "}
                        </p>
                        <p>
                            2.12. The Consultant understands that MYLO makes no
                            promise or guarantee for the number of consultations
                            that will be allocated to a Consultant on the
                            Consult platform. The consultations allocated to a
                            Consultant will depend upon various factors, which
                            inter-alia includes, Consult response time, patient
                            feedback and number of Consultants available, etc.{" "}
                        </p>
                        <p>
                            2.13. It shall be the responsibility of the
                            Consultant to ensure that the information provided
                            by User is accurate and not incomplete and
                            understand that MYLO shall not be liable for any
                            errors in the information included in any
                            communication between the Consultant and User.{" "}
                        </p>
                        <h3>3. REFUND </h3>
                        <p>
                            3.1. Please note that all returns and related
                            procedures shall be carried out by the Vendor(s)
                            whose products have been purchased by You.
                            Therefore, Mylo shall not be liable for any loss,
                            damages, action, claim or liability arising out of
                            or in connection with any act, omission or
                            negligence of such a Vendor with respect to the
                            return of purchased product(s).
                        </p>
                        <p>
                            3.2. Subject to the restrictions contained in Our
                            cancellation policy, a request for the cancellation
                            of Your order can be sent to Mylo before the date of
                            service and before You receive an email containing
                            confirmation of dispatch of the products.
                        </p>
                        <p>
                            3.3. Once the cancellation has been accepted by
                            Mylo, You will be intimated about the same by way of
                            an email or a phone call on the e-mail ID and
                            telephone number provided by You. Any refund against
                            a request for a return or the products shall be
                            processed only upon receipt of the product by the
                            Vendor along with the original invoice. In case of
                            services intended to be availed by You, the refund
                            will be subject to the cancellation policy as per
                            Clause 8. It may take up to 10-14 business days for
                            the credit to reflect in Your account. The actual
                            time taken for refund or credit of the payment into
                            your account depends on the mode by which the
                            payment was made and the procedures adopted by
                            various financial services providers.
                        </p>
                        <h3>4. DISCLAIMERS </h3>
                        <p>
                            3.1. The Consultation services available on the Mylo
                            Web Platforms is intended for general purposes only
                            and is not meant to be used in emergencies/serious
                            illnesses requiring physical consultation. Further,
                            if the Consultant adjudges that a physical
                            examination would be required and advises ‘in-person
                            consultation’, it is the sole responsibility of the
                            User, to book an appointment for physical
                            examination and in-person consultation whether the
                            same is with the Consultant listed on the Mylo Web
                            Platforms or otherwise. In case of any negligence on
                            the part of the User in acting on the same and the
                            condition of the User deteriorates, Mylo shall not
                            be held liable.{" "}
                        </p>
                        <p>
                            3.2. The consultation services are being made
                            available to Users to assist them to obtain
                            consultation from Consultants and does not intend to
                            replace the physical consultation with the
                            Consultant.{" "}
                        </p>

                        <h3 className="term">D. GENERAL PROVISIONS</h3>
                        <h3>1. FORCE MAJEURE</h3>
                        <p>
                            You understand and agree that Mylo will not be held
                            liable for any loss or damage with respect to the
                            use of the Mylo Web Platforms, if the same arises
                            out of any cause due to which Mylo is wholly or
                            partly unable to perform its obligations and which
                            is not reasonably within the control of Mylo.
                            Further, Mylo will not liable for any loss or damage
                            which is not a result of the fault or negligence of
                            Mylo or which occurs despite all reasonable attempts
                            of Mylo to avoid or mitigate the same. This includes
                            without limitation, acts of God, war, riots, civil
                            disturbances, cyclones, hurricanes, floods,
                            earthquakes, storms and other natural calamities,
                            epidemics, plagues, terrorist attacks, accidents,
                            trade restrictions, acts of any government authority
                            leading to a delay in adhering to the timelines of
                            delivery, strikes, labour, employee difficulties and
                            other events or circumstances that are beyond the
                            reasonable control of Mylo.
                        </p>
                        <h3>2. INDEMNIFICATION</h3>
                        <p>
                            You agree to indemnify and hold Us and (as
                            applicable) Our officers, directors, agents, and
                            employees, harmless from any claim or demand,
                            including reasonable attorneys&apos; fees, made by
                            any third party due to or arising out of Your breach
                            of these Terms or your violation of any law, or your
                            violation of the rights of a third party, including
                            the infringement by you of any intellectual property
                            or other right of any person or entity. These
                            obligations will survive the termination of these
                            Terms.
                        </p>
                        <h3>3. TERMINATION</h3>
                        <p>
                            You understand and agree that Mylo reserves the
                            right to terminate Your registration and / or
                            terminate Your right to use the Mylo Web Platforms
                            for any reason whatsoever, including without
                            limitation, any act or omission in contravention of
                            the Privacy Policy or of these Terms. You further
                            understand and agree that any such termination may
                            be effected without prior notice to You and You
                            acknowledge and agree that Mylo may delete or
                            deactivate Your account immediately upon detecting
                            any such reason, including without limitation, the
                            contravention of the Privacy Policy or of these
                            Terms.
                        </p>
                        <h3>4. APPLICABLE LAW</h3>
                        <p>
                            4.1. The Mylo Web Platforms have been designed to
                            comply with the laws of India and hence We shall be
                            governed by the laws of India. If any material on
                            the Mylo Web Platforms or Your use of the Mylo Web
                            Platforms is contrary to the laws of the country /
                            state where You are when You access it, We ask You
                            not to use the Mylo Web Platforms in contravention
                            of such law. You are responsible for being aware of
                            the laws of Your jurisdiction and complying with
                            them.
                        </p>
                        <p>
                            4.2. Further, the courts of Mumbai shall have
                            exclusive jurisdiction in case of any preliminary
                            relief sought in respect of all the terms,
                            conditions and disclaimers.
                        </p>
                        <h3>5. DISPUTE RESOLUTION</h3>
                        <p>
                            All disputes or differences arising between You and
                            Mylo as to these Terms or any other matter in
                            relation to or in connection with Your use of the
                            Mylo Web Platforms, shall be referred to a single
                            arbitrator who shall be appointed by Us as per the
                            provisions of the Arbitration and Conciliation Act,
                            1996 or any amendments thereto. The seat of
                            arbitration shall be Mumbai and the language should
                            be English.
                        </p>
                        <h3>6. MISCELLANEOUS</h3>
                        <p>
                            You agree and acknowledge You are solely responsible
                            for compliance with applicable laws. If for any
                            reason a court of competent jurisdiction finds any
                            provision or portion of the Terms to be
                            unenforceable, the remainder of the Terms will
                            continue in full force and effect. These Terms
                            constitute the entire agreement between Us and
                            supersedes and replaces all prior or contemporaneous
                            understandings or agreements, written or oral,
                            regarding the subject matter of these Terms. Mylo
                            reserves the right to investigate complaints or
                            reported violations of these Terms and to take any
                            action we deem necessary and appropriate. Such
                            action may include reporting any suspected unlawful
                            activity to law enforcement officials, regulators,
                            or other third parties. In addition, We may take
                            action to disclose any information necessary or
                            appropriate to such persons or entities relating to
                            User profiles, email addresses, usage history,
                            posted materials, IP addresses and traffic
                            information. Mylo reserves the right to seek all
                            remedies available at law and in equity for
                            violations of these Terms.
                        </p>
                        <h3>7. NOTICES</h3>
                        <p>
                            All of Our notices, demands and other communications
                            must be in writing and will be deemed to have been
                            given (a) if mailed by certified mail, postage
                            prepaid, (b) if delivered by overnight courier, or
                            (c) if sent by electronic mail, and such message is
                            confirmed as received, in each case to the address,
                            fax number or email address specified on the Order
                            for the recipient of such notice. All of Your
                            notices, demands and other communications must be in
                            writing and will be deemed to have been given (a) if
                            mailed by certified mail, postage prepaid or if
                            delivered by overnight courier, to Our address.
                        </p>
                        <h3>8. GRIEVANCE OFFICER</h3>
                        <p>
                            In accordance with Information Technology Act 2000
                            and rules made there under, the name and contact
                            details of the Grievance Officer who can be
                            contacted with respect to any complaints or concerns
                            including those pertaining to breach of these Terms,
                            and other policies or questions are published as
                            under:
                        </p>
                        <p>Name: Mr. Vishal Naithani</p>
                        <p>E-mail address: feedback@mylofamily.com</p>
                        <p>
                            [10:00 AM to 6:00 PM from Monday to Friday except
                            Public Holidays]
                        </p>
                    </div> */}
          <TermsAndConditionPage />
        </PolicyContainer>
      </HomeWrapper>
      <NewFooter />
    </>
  );
}

export default termOfUse;
